{
	"flag": "🇵🇱",
	"common": {
		"add": "Dodaj",
		"create": "Utwórz",
		"e-mail": "E-mail",
		"edit": "Edytuj",
		"no": "Nie",
		"or": "Lub",
		"password": "Hasło",
		"save": "Zapisz",
		"select": "Wybierz",
		"selected": "Wybrany",
		"select-all": "Wybierz wszystkich",
		"selected-all": "Wybrano wszystkich",
		"sign-out": "Wyloguj się",
		"username": "Nazwa użytkownika",
		"yes": "Tak",
		"language": "Język",
		"saving": "Zapisywanie",
		"delete": "Usuń",
		"next": "Dalej",
		"get-started": "Zacznij",
		"skip": "Pomiń",
		"optional": "opcjonalne",
		"read-more": "Czytaj więcej",
		"show-less": "Pokaż mniej",
		"cancel": "Anuluj",
		"search": "Szukaj",
		"send": "Wyślij",
		"done": "Gotowe",
		"password-requirements-hint": "Min {{minLength}} znaków, jedna cyfra, jeden znak specjalny",
		"enter-your-email": "Wprowadź swój email",
		"enter-your-username": "Wpisz twoją nazwę użytkownika",
		"create-a-password": "Stwórz hasło",
		"enter-your-password": "Wprowadź hasło"
	},
	"login": {
		"dont-have-an-account": "Nie masz konta?",
		"forgot-password": "Zapomniałeś hasła?",
		"sign-in": "Zaloguj się",
		"sign-up": "Zarejestruj się",
		"to-keep-connected-with-us-please-login-to-your-account": "Aby pozostać z nami w kontakcie, zaloguj się na swoje konto",
		"welcome-back": "Witamy z powrotem",
		"please-enter-your-email-an-email-will-be-sent-to-it-to-reset-your-password": "Podaj swój adres, na który zostanie wysłany e-mail, aby zresetować hasło",
		"create-new-password": "Utwórz nowe hasło",
		"set-new-password": "Ustaw nowe hasło",
		"password-updated": "Hasło zaktualizowane",
		"your-password-has-been-successfully-changed": "Twoje hasło zostało zmienione.",
		"password-set-successfully": "Hasło ustawione pomyślnie",
		"you-can-login-now": "Możesz się teraz zalogować"
	},
	"register": {
		"create-account": "Utwórz konto",
		"do-you-have-account": "Masz konto?",
		"repeat-password": "Powtórz hasło",
		"agree-to": "Zakładając konto, wyrażasz zgodę na naszą",
		"privacy-policy-and-eula": "Politykę prywatności i EULA",
		"hello-friend": "Witaj przyjacielu!",
		"provide-your-personal-details": "Podaj swoje dane osobowe i zacznij się z nami rozwijać",
		"sign-up-for-a-newsletter": "Zapisz się do naszego newslettera i zostań częścią naszej społeczności!"
	},
	"forgot-password": {
		"sent-please-check-your-email": "Wysłano email, sprawdź pocztę"
	},
	"profile": {
		"delete-account": "Usuń konto",
		"this-action-cannot-be-undone": "Tej czynności nie można cofnąć"
	},
	"validations": {
		"error": "Błąd"
	},
	"change-password": {
		"modal": {
			"title": "Zmień hasło",
			"submit": "Zmień hasło"
		},
		"old-password": "Stare hasło",
		"new-password": "Nowe hasło",
		"repeat-new-password": "Powtórz nowe hasło",
		"invalid-password": "Nieprawidłowe hasło",
		"passwords-do-not-match": "Hasła nie pasują",
		"password-changed": "Hasło zostało zmienione",
		"new-password-must-be-different-from-the-old-one": "Nowe hasło musi być różne od poprzedniego"
	}
}
